import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import styles from './ProgressBar.module.css'

export type SegmentVariant = 'black' | 'red' | 'blue' | 'green'

export interface Segment {
  variant: SegmentVariant
  value: number
  valueSuffix: string
  label: string
  count?: number
}

interface ProgressBarProps {
  segments: Segment[]
  max: number
  title: string
}

const VARIANT_CLASS: Record<SegmentVariant, string> = {
  black: styles.variantBlack,
  red: styles.variantRed,
  blue: styles.variantBlue,
  green: styles.variantGreen,
}

export function ProgressBar({ segments, max, title }: ProgressBarProps) {
  const visibleSegments = segments.filter(s => s.value > 0)
  const barDescription = segments.map(s => `${s.label}: ${s.value}${s.valueSuffix}`).join(', ')

  return (
    <>
      <div
        className={styles.bar}
        role="img"
        aria-label={`${title} — ${barDescription}`}
      >
        {visibleSegments.map(segment => (
          <div
            key={segment.variant}
            className={cn(styles.segment, VARIANT_CLASS[segment.variant])}
            style={{ '--segment-width': `${(segment.value / max) * 100}%` } as React.CSSProperties}
          />
        ))}
      </div>

      <ul className={styles.legend} aria-label="Slope breakdown">
        {segments.map(segment => (
          <li key={segment.variant} className={styles.legendItem}>
            <span
              className={cn(styles.legendDot, VARIANT_CLASS[segment.variant])}
              aria-hidden="true"
            />
            <Typography variant="body-s-bold-tight" as="span">
              {`${segment.value} ${segment.valueSuffix} ${segment.label}`}
            </Typography>
          </li>
        ))}
      </ul>
    </>
  )
}
